import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner } from 'common/components/centered-spinner';
import { NotificationCount } from '../component/parts/notifications';
import { useNotificationQuery } from '../queries';

interface INotificationContainerProps {
    isMenuCollapsed: boolean;
}

export function NotificationContainer(props: INotificationContainerProps) {
    const { isMenuCollapsed } = props;
    const { data, isLoading, error } = useNotificationQuery();
    const translate =useTranslate();

    if (isLoading) {
        return <CenteredSpinner size='small' spinnerType='indeterminate' text={translate('modules.defaultAppSettings.notificationList.loadingNotificationText')} />;
    }

    if (data) {
        const notificationCount = getNotificationLength(data.GetNotificationsResult);
        return (<NotificationCount notificationCount={notificationCount} isMenuCollapsed={isMenuCollapsed} />);
    }

    return (
        <>
            <span>Error: {error}</span>
        </>
    );
}

const getNotificationLength = (data: any): number => (data ? data.length : 0);
